import React from "react";

const DocumentsContext = React.createContext(null);

export default DocumentsContext;
